var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        title:
          _vm.drawRow.type === "edit"
            ? "编辑角色"
            : _vm.$t("system::rbac::新增角色"),
        visible: _vm.dialogVisible,
        width: "500px",
      },
      on: {
        close: _vm.onChange,
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "label-position": "left",
            "label-width": "100px",
          },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "roleName",
                label: _vm.$t("system::rbac::角色姓名"),
              },
            },
            [
              _c("el-input", {
                attrs: { maxlength: 12, "show-word-limit": "" },
                model: {
                  value: _vm.form.roleName,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "roleName", $$v)
                  },
                  expression: "form.roleName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "roleDesc",
                label: _vm.$t("system::rbac::角色描述"),
              },
            },
            [
              _c("el-input", {
                attrs: { maxlength: 100, "show-word-limit": "" },
                model: {
                  value: _vm.form.roleDesc,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "roleDesc", $$v)
                  },
                  expression: "form.roleDesc",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "footer_class",
          staticStyle: { "text-align": "center", display: "block" },
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.onChange } }, [
            _vm._v(_vm._s(_vm.$t("system::common::btn::cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.sumbit },
            },
            [_vm._v(_vm._s(_vm.$t("system::common::btn::confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }